import { memo } from 'react';

import { WORKSPACE_AGENT_PANEL_SNAP_THRESHOLD_PX } from '~/components/v2/components/workspace/workspace-agent-panel/workspaceAgentPanelConstants';

export const WorkspaceAgentPanelSnapToRightGuide = memo(() => (
  <div
    aria-hidden
    className="pointer-events-none fixed inset-y-0 right-0 z-1 box-border ads:border-default border-gray-5 border-l ads:bg-ads-gray-4/45 bg-gray-4/45"
    data-testid="WORKSPACE_AGENT_PANEL_SNAP_TO_RIGHT_GUIDE"
    style={{ width: WORKSPACE_AGENT_PANEL_SNAP_THRESHOLD_PX * 2 }}
  />
));

WorkspaceAgentPanelSnapToRightGuide.displayName = 'WorkspaceAgentPanelSnapToRightGuide';
